import LegalLayout from "@/components/LegalLayout";
import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/site";

const H = ({ children }) => (
  <h2 className="font-heading font-bold text-xl text-[#1A110B] pt-4">{children}</h2>
);

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <LegalLayout title="Privacy Policy" updated="June 2026">
        <p>
          {COMPANY.name} ("we," "us," or "our") respects your privacy. This Privacy Policy explains
          how we collect, use, and protect information when you visit {COMPANY.domain} or engage our
          IT services.
        </p>

        <H>1. Information We Collect</H>
        <p>
          When you submit our contact form, we collect the information you provide — such as your
          name, email address, phone number, company, service of interest, and message. In the
          course of delivering services, we may also collect business and technical information
          necessary to support your systems.
        </p>

        <H>2. How We Use Your Information</H>
        <p>
          We use your information to respond to inquiries, provide quotes, deliver and support our
          services, process payments, and communicate with you about your account. We do not sell
          your personal information.
        </p>

        <H>3. SMS / Text Messaging &amp; Mobile Information</H>
        <p>
          If you provide your mobile number and opt in, we may send you SMS text messages such as
          appointment reminders, service and account updates, and responses to your inquiries.
          Message frequency varies. Message and data rates may apply. You can opt out at any time by
          replying <strong>STOP</strong>, and reply <strong>HELP</strong> for help.
        </p>
        <p>
          <strong>No mobile information will be shared with third parties or affiliates for
          marketing or promotional purposes.</strong> All the above categories exclude text
          messaging originator opt-in data and consent; this information will not be shared with any
          third parties. Mobile information may be shared with subcontractors only in support
          services, such as customer service, and solely to help us provide the services you
          requested.
        </p>

        <H>4. Payment Processing</H>
        <p>
          Payments made through the "Make a Payment" link are processed by a secure third-party
          payment provider. Beta-Tech Systems does not store your full card details on this website.
          Your payment information is handled in accordance with the provider's privacy and security
          practices.
        </p>

        <H>5. Cookies & Analytics</H>
        <p>
          Our website may use cookies or similar technologies to improve functionality and
          understand how visitors use the site. You can control cookies through your browser
          settings.
        </p>

        <H>6. Data Sharing</H>
        <p>
          We may share information with trusted service providers (such as our payment processor)
          who help us operate our business, and when required by law. These parties are only
          permitted to use your information to perform services on our behalf. As stated above,
          mobile opt-in and SMS consent data is never shared with third parties or affiliates for
          marketing purposes.
        </p>

        <H>7. Data Security</H>
        <p>
          We take reasonable measures to protect the information we collect. However, no method of
          transmission or storage is completely secure, and we cannot guarantee absolute security.
        </p>

        <H>8. Your Choices</H>
        <p>
          You may request access to, correction of, or deletion of the personal information we hold
          about you by contacting us through our{" "}
          <Link to="/contact" className="text-[#00B4C4] font-medium">contact form</Link>.
        </p>

        <H>9. Changes to This Policy</H>
        <p>
          We may update this Privacy Policy periodically. Updates will be posted on this page with a
          revised "Last updated" date.
        </p>
      </LegalLayout>
    </div>
  );
}
